import { Sparkles, ArrowRight } from "lucide-react";

/**
 * AnnouncementBar — black thin strip pinned above the nav. Subtle
 * gold/yellow accent kept minimal so it reads premium, not promotional.
 */
export default function AnnouncementBar() {
  return (
    <div
      role="region"
      aria-label="Announcement"
      className="w-full bg-black text-white text-xs md:text-sm font-semibold tracking-wide py-2.5 px-4"
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-center">
        <Sparkles className="w-3.5 h-3.5 text-[#FFD500] shrink-0" aria-hidden="true" />
        <span>
          Free Student Access Available For A Limited Time
          <span className="hidden sm:inline mx-2 text-white/40">•</span>
          <span className="hidden sm:inline">
            Start Your Entrepreneurship Journey Today
          </span>
        </span>
        <ArrowRight className="hidden md:inline w-3.5 h-3.5 text-[#FFD500] shrink-0" aria-hidden="true" />
      </div>
    </div>
  );
}
